import { Link } from 'react-router-dom'

// #334: one tag pill, one colour, everywhere a tag is shown on a card.
//
// The `conference` pill is brand-blue and means "this row is a container".
// Tags mean something else entirely, so they get their own hue (violet) rather
// than the neutral slate they used to share with the format pill — slate read
// as chrome and the tags disappeared into it.
//
// #338: a tag is a filter, so given an `href` the pill becomes its permalink.
// Without one it stays plain text — the event detail page shows tags for
// context, not as navigation.
const CLASS = 'inline-flex items-center rounded-full bg-violet-100 px-2.5 py-0.5 text-xs font-medium text-violet-800'

export default function TagPill({ tag, href }) {
  const label = tag.name || tag.slug
  if (!href) return <span className={CLASS}>{label}</span>
  return <Link to={href} className={`${CLASS} transition hover:bg-violet-200`}>{label}</Link>
}
